export default {
  deleteTask: { id: 'delete_task' },
  editTask: { id: 'edit_task' },
  name: { id: 'name' },
  email: { id: 'email' },
  dateUpdated: { id: 'date_updated' },
  createDate: { id: 'create_date' },
  groups: { id: 'groups' },
  active: { id: 'active' },
  jobWorkflowTaskAdmin: { id: 'job_workflow_task_admin' },
  jobWorkflowTaskInfo: { id: 'job_workflow_task_info' },
  saveBtn: { id: 'save_btn' },
  saveInfo: { id: 'save_info' },
  needsLocus: { id: 'needs_locus' },
  needsLocusGroup: { id: 'needs_locus_group' },
  title: { id: 'title' },
  position: { id: 'position' },
  duplicable: { id: 'duplicable' },
  optional: { id: 'optional' },
  jobApprovalTask: { id: 'job_approval_task' },
  workflow: { id: 'workflow' },
  instructions: { id: 'instructions' },
  imagePath: { id: 'image_path' },
  youtubeVideoLink: { id: 'youtube_video_link' },
  deleteTaskMessage: { id: 'delete_task_message' },
  createTask: { id: 'create_task' },
  users: { id: 'users' },
  userGroups: { id: 'user_groups' },
  uploadPngJpg: { id: 'upload_png_jpg' },
  indicators: { id: 'monitors_and_alerts_indicators' },
  goToInputs: { id: 'go_to_inputs' },
  needsUnit: { id: 'needs_unit' },
  needsUnitGroup: { id: 'needs_unit_group' },
  multiUnitSelection: { id: 'multi_unit_selection' },
  searchBySite: { id: 'search_by_site' },
  assigned: { id: 'assigned' },
  userGroup: { id: 'user_group' },
  searchByUser: { id: 'search_by_user' },
  individualSiteAssigment: { id: 'individual_site_assignment' },
  bulkSiteAssigment: { id: 'bulk_site_assignment' },
  assignee: { id: 'assignee' },
  deleteAssign: { id: 'delete_assign' },
  deleteAssignMessage: { id: 'delete_assign_message' },
  assignment: { id: 'assignment' },
  site: { id: 'site' },
  allSites: { id: 'all_sites' },
  actions: { id: 'actions' },
  clearAssignList: { id: 'clear_assign_list' },
  clearAssignListMessage: { id: 'clear_assign_list_message' },
  clearAll: { id: 'clear_all' },
  selectAll: { id: 'select_all' },
  chooseSite: { id: 'choose_site' },
  chooseAssignees: { id: 'choose_assignees' },
  useUnitsFromTable: { id: 'use_units_from_table' },
  useUnitsFromColumn: { id: 'use_units_from_column' },
  useUnitGroupsFromTable: { id: 'use_unit_groups_from_table' },
  useUnitGroupsFromColumn: { id: 'use_unit_groups_from_column' },
  createsNewRowInTheTable: { id: 'creates_new_row_in_the_table' },
}
